export interface GestationalAge {
  weeks: number;
  days: number;
  label: string;
}

export interface GpladValue {
  g: number | "";
  p: number | "";
  l: number | "";
  a: number | "";
  d: number | "";
}

export function calculateEDDFromLMP(lmpDate: string, cycleLengthDays = 28): Date | null {
  if (!lmpDate) return null;
  const lmp = new Date(lmpDate);
  if (isNaN(lmp.getTime())) return null;
  const adjustment = cycleLengthDays - 28;
  return new Date(lmp.getTime() + (280 + adjustment) * 24 * 60 * 60 * 1000);
}

export function formatDate(date: Date | null): string {
  if (!date) return "";
  return date.toISOString().slice(0, 10);
}

export function calculateGAFromEDD(eddDate: Date | string): GestationalAge | null {
  const edd = typeof eddDate === "string" ? new Date(eddDate) : eddDate;
  if (!edd || isNaN(edd.getTime())) return null;
  const today = new Date();
  const daysUntilEDD = Math.floor((edd.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
  const daysPregnant = 280 - daysUntilEDD;
  if (daysPregnant < 0) return null;
  const weeks = Math.floor(daysPregnant / 7);
  const days = daysPregnant % 7;
  return { weeks, days, label: days > 0 ? `${weeks}w ${days}d` : `${weeks}w` };
}

export function calculateGestationalAge(lmpDate: string): GestationalAge | null {
  if (!lmpDate) return null;
  const lmp = new Date(lmpDate);
  const today = new Date();
  const diffMs = today.getTime() - lmp.getTime();
  if (diffMs < 0) return null;
  const totalDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const weeks = Math.floor(totalDays / 7);
  const days = totalDays % 7;
  const label = days > 0 ? `${weeks}w ${days}d` : `${weeks}w`;
  return { weeks, days, label };
}

export function parseGplad(value: any): GpladValue {
  if (typeof value === "object" && value !== null) {
    return {
      g: value.g ?? "",
      p: value.p ?? "",
      l: value.l ?? "",
      a: value.a ?? "",
      d: value.d ?? "",
    };
  }
  return { g: "", p: "", l: "", a: "", d: "" };
}

export function formatGplad(val: GpladValue): string {
  const parts = [
    val.g !== "" ? `G${val.g}` : null,
    val.p !== "" ? `P${val.p}` : null,
    val.l !== "" ? `L${val.l}` : null,
    val.a !== "" ? `A${val.a}` : null,
    val.d !== "" ? `D${val.d}` : null,
  ].filter(Boolean);
  return parts.join(" ");
}
